module.exports = __webpack_public_path__ + "img/image1.29e9ae8b.svg";